import { useParams } from 'react-router';
import SellerContractListHead from '../components/SellerContractListHead';
import SellerContractTable from '../components/table/SellerContractTable';
import { useEffect, useState } from 'react';
import { stateKorea } from '../../utils/Languages';
import buskwarehousedetail from '../services/buskwarehousedetail';

const SellerContract = () => {
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(false);
  const [rowDataWarehouse, setRowDataWarehouse] = useState();
  const [totalWarehouse, setTotalWarehouse] = useState(0);
  const [selectedSellerContact, setSelectedSellerContact] = useState<
    React.Key[]
  >([]);
  const [pageSellerContract, setPageSellerContract] = useState(1);

  useEffect(() => {
    getSellerContactList(id, pageSellerContract);
  }, [id, pageSellerContract]);

  const handleChangePageSellerContract = (page: number) => {
    setPageSellerContract(page);
  };

  const getSellerContactList = async (id: string, page: number) => {
    setLoading(true);
    const buskWarehouseDetail = await buskwarehousedetail.getSellerContactList(
      id,
      page
    );
    const rowDataModified = buskWarehouseDetail.data?.map(
      (r: any, index: number) => {
        return {
          ...r,
          key: r.productId,
          // no: index + (page - 1) * 10 + 1,
          no: r.id,
          state: stateKorea(r.state)
        };
      }
    );
    // setRowDataWarehouse(buskWarehouseDetail.data);
    setRowDataWarehouse(rowDataModified);
    setTotalWarehouse(buskWarehouseDetail.count);
    setLoading(false);
  };
  return (
    <>
      <SellerContractListHead
        totalWarehouse={totalWarehouse}
        selectedSellerContact={selectedSellerContact}
      />
      <SellerContractTable
        loading={loading}
        rowDataWarehouse={rowDataWarehouse}
        totalWarehouse={totalWarehouse}
        getSellerContactList={getSellerContactList}
        selectedSellerContact={selectedSellerContact}
        setSelectedSellerContact={setSelectedSellerContact}
        handleChangePageSellerContract={handleChangePageSellerContract}
      />
    </>
  );
};

export default SellerContract;
